export default "__VITE_ASSET__BmsmarQd__"